import type { AppTheme, AuthConfig, PaymentResponse, PortalConfigResponse } from "@token/shared";
import type { BrandingName } from "../branding";

export type { Auth0Config, AuthConfig, AuthProviderName, GoogleAuthConfig } from "@token/shared";

export enum PaymentProviderName {
  Mock = "MOCK",
  Adyen = "ADYEN",
  Stripe = "STRIPE",
}

export type PaymentEnvironment = "test" | "live";

export function paymentProviderLabel(provider: PaymentProviderName | string | undefined): string {
  switch (provider?.toUpperCase()) {
    case PaymentProviderName.Adyen:
      return "Adyen";
    case PaymentProviderName.Stripe:
      return "Stripe";
    case PaymentProviderName.Mock:
      return "Mock";
    default:
      return provider ?? "Payment Provider";
  }
}

export interface PaymentConfig extends Omit<PaymentResponse, "provider" | "environment"> {
  provider: PaymentProviderName;
  environment?: PaymentEnvironment;
}

export interface AppConfig extends Omit<PortalConfigResponse, "auth" | "payment" | "theme" | "branding"> {
  auth: AuthConfig;
  payment: PaymentConfig;
  theme: AppTheme;
  branding: BrandingName;
}

export interface ConfigSource {
  readonly name: string;
  load(): Promise<AppConfig>;
}
